export default __webpack_public_path__ + "static/media/professor.ebbbd7ef.png";